import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "profile-content--entrepreneur" }
const _hoisted_2 = { class: "info-item info-item--sectors profile-content-row profile-content__tags" }
const _hoisted_3 = { class: "profile-content__caption" }
const _hoisted_4 = { class: "info-item info-item--md-half info-item--founded" }
const _hoisted_5 = { class: "profile-content__caption" }
const _hoisted_6 = { class: "profile-content__data" }
const _hoisted_7 = {
  key: 1,
  class: "profile-content__empty-data"
}
const _hoisted_8 = { class: "info-item info-item--md-half info-item--about" }
const _hoisted_9 = { class: "profile-content__caption" }
const _hoisted_10 = { class: "profile-content__data" }
const _hoisted_11 = {
  key: 1,
  class: "profile-content__empty-data"
}
const _hoisted_12 = { class: "info-item info-item--md-half info-item--website" }
const _hoisted_13 = { class: "profile-content__caption" }
const _hoisted_14 = { class: "profile-content__data" }
const _hoisted_15 = ["href"]
const _hoisted_16 = {
  key: 2,
  class: "profile-content__empty-data"
}
const _hoisted_17 = { class: "info-item info-item--md-half info-item--email" }
const _hoisted_18 = { class: "profile-content__caption" }
const _hoisted_19 = ["textContent"]
const _hoisted_20 = { class: "profile-content__data" }
const _hoisted_21 = ["href"]
const _hoisted_22 = {
  key: 3,
  class: "profile-content__hidden-email"
}
const _hoisted_23 = { class: "profile-content__hidden-email-title" }
const _hoisted_24 = { class: "profile-content__hidden-email-subtitle" }
const _hoisted_25 = {
  key: 4,
  class: "profile-content__empty-data"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ElTag = _resolveComponent("ElTag")!
  const _component_PxButton = _resolveComponent("PxButton")!
  const _component_ElTooltip = _resolveComponent("ElTooltip")!
  const _component_PxIcon = _resolveComponent("PxIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h4", _hoisted_3, _toDisplayString(_ctx.$t("profile.company.sector")), 1),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.company.sectors, (sector) => {
        return (_openBlock(), _createBlock(_component_ElTag, {
          key: sector.id,
          class: "text--capitalize",
          effect: "plain"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(sector.name), 1)
          ]),
          _: 2
        }, 1024))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("h4", _hoisted_5, _toDisplayString(_ctx.$t("profile.company.foundedDate")), 1),
      _createElementVNode("div", _hoisted_6, [
        _createTextVNode(_toDisplayString(_ctx.companyFoundedDate) + " ", 1),
        (!_ctx.company.founded_date && _ctx.$user.isOwner())
          ? (_openBlock(), _createBlock(_component_PxButton, {
              key: 0,
              class: "el-button--link el-button--link-blue",
              type: "link",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onClickFieldHandler()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("profile.company.emptyState.foundedDate")), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (!_ctx.company.founded_date && !_ctx.$user.isOwner())
          ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.$t("profile.company.emptyState.visitor")), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("h4", _hoisted_9, _toDisplayString(_ctx.$t("profile.company.about")), 1),
      _createElementVNode("div", _hoisted_10, [
        _createTextVNode(_toDisplayString(_ctx.company.about) + " ", 1),
        (!_ctx.company.about && _ctx.$user.isOwner())
          ? (_openBlock(), _createBlock(_component_PxButton, {
              key: 0,
              class: "el-button--link el-button--link-blue",
              type: "link",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onClickFieldHandler('about')))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("profile.company.emptyState.about")), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (!_ctx.company.about && !_ctx.$user.isOwner())
          ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.$t("profile.company.emptyState.visitor")), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("h4", _hoisted_13, _toDisplayString(_ctx.$t("profile.company.website")), 1),
      _createElementVNode("div", _hoisted_14, [
        (_ctx.company.website)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              href: _ctx.companyWebsite,
              class: "el-button el-button--link el-button--link-dark",
              target: "_blank"
            }, [
              _createElementVNode("span", null, _toDisplayString(_ctx.company.website), 1)
            ], 8, _hoisted_15))
          : (_ctx.$user.isOwner())
            ? (_openBlock(), _createBlock(_component_PxButton, {
                key: 1,
                class: "el-button--link el-button--link-blue",
                type: "link",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onClickFieldHandler('website')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("profile.company.emptyState.website")), 1)
                ]),
                _: 1
              }))
            : (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.$t("profile.company.emptyState.visitor")), 1))
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("h4", _hoisted_18, [
        _createTextVNode(_toDisplayString(_ctx.$t("profile.company.email")) + " ", 1),
        (_ctx.$user.isOwner())
          ? (_openBlock(), _createBlock(_component_ElTooltip, {
              key: 0,
              placement: "top",
              "popper-class": "profile-content__caption-tooltip el-abaca-tooltip"
            }, {
              content: _withCtx(() => [
                _createElementVNode("div", {
                  textContent: _toDisplayString(_ctx.$t(`profile.company.tooltip.emailVisibility`))
                }, null, 8, _hoisted_19)
              ]),
              default: _withCtx(() => [
                _cache[4] || (_cache[4] = _createElementVNode("i", { class: "icon icon-question" }, null, -1))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_20, [
        (_ctx.canShowEmail)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              href: `mailto:${_ctx.company.email}`,
              class: "el-button el-button--link el-button--link-dark"
            }, [
              _createElementVNode("span", null, _toDisplayString(_ctx.company.email), 1)
            ], 8, _hoisted_21))
          : (_ctx.$user.isOwner())
            ? (_openBlock(), _createBlock(_component_PxButton, {
                key: 1,
                class: "el-button--link el-button--link-blue",
                type: "link",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onClickFieldHandler('email')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("profile.company.emptyState.email")), 1)
                ]),
                _: 1
              }))
            : (!_ctx.hasUserAccess)
              ? (_openBlock(), _createBlock(_component_PxButton, {
                  key: 2,
                  class: "el-button--link el-button--link-green",
                  type: "link",
                  onClick: _ctx.onClickSignUp
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("profile.company.visitorState.email")), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : (_ctx.userCanMatch)
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _createElementVNode("p", _hoisted_23, [
                      _createVNode(_component_PxIcon, {
                        name: 'icon-password',
                        size: 12
                      }),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t(
                `profile.company.hiddenEmail[${
                  _ctx.userIsInterested ? 1 : 0
                }].title`,
                { name: _ctx.company.name },
              )), 1)
                    ]),
                    _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.$t(
                `profile.company.hiddenEmail[${
                  _ctx.userIsInterested ? 1 : 0
                }].subtitle`,
              )), 1)
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_ctx.$t("profile.company.emptyState.visitor")), 1))
      ])
    ])
  ]))
}